<div class="email-verification">
  <div class="email-verification__container"
       fxLayout="row"
       fxLayoutAlign="space-between start">
    <div class="email-verification__message">
      Please verify your email
    </div>
    <div class="email-verification__icon">
      <mat-icon (click)="onClose()">close</mat-icon>
    </div>
  </div>
  <div class="email-verification__additional-info">
    <div class="email-verification__info-text">
      You're almost there! We just sent an email to
      <div class="email-verification__email-display">
        {{ email }}
      </div>
    </div>
  </div>
  <div class="email-verification__footer">
    <div class="email-verification__footer-text">
      Just click on the link in that email to complete your signup.
    </div>
    <div class="email-verification__footer-text">
      If you don't see it, check your spam folder or click the button to resend it.
    </div>
  </div>
  <div class="email-verification__resend">
    <button mat-raised-button
            class="email-verification__resend-button"
            (click)="onResendEmail()"
            [ngStyle]="{ 'background-color': isDisable || isCountingDown ? 'grey' : '#2142FF'}"
            [disabled]="isDisable || isCountingDown">
      <div fxLayout="row"
           fxLayoutAlign="center center"
           fxLayoutGap="1rem"
           *ngIf="!isCountingDown">
        Resend Email
      </div>
      <div *ngIf="isCountingDown">
        Resend available in ({{ countdown }}) seconds
      </div>
    </button>
  </div>
</div>
